import React from 'react';

const channels = [
  { name: 'Voice', desc: 'Outbound & inbound calls', color: '#0a9e8f' },
  { name: 'SMS', desc: 'Automated text campaigns', color: '#077a6e' },
  { name: 'WhatsApp', desc: 'Business messaging API', color: '#056055' },
  { name: 'Webchat', desc: 'Live site chat widget', color: '#0B6860' },
  { name: 'Email', desc: 'Triggered & drip emails', color: '#095550' },
];

export default function Channels() {
  return (
    <div id="support" style={{ background: '#0a0a0a', borderTop: '1px solid rgba(10,158,143,0.13)', borderBottom: '1px solid rgba(10,158,143,0.13)' }}>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '4rem 2.5rem' }}>
        <div className="channels-grid">
          <div>
            <div style={tag}>// OMNICHANNEL</div>
            <h2 style={head}>Every channel. <span style={{ color: '#0a9e8f' }}>One screen.</span></h2>
            <p style={{ fontSize: '0.875rem', color: '#909090', marginTop: 12, fontWeight: 300, lineHeight: 1.7 }}>Agents see full cross-channel history. No app switching. No missed context.</p>
            <div style={{ display: 'flex', gap: 8, marginTop: '1.75rem', flexWrap: 'wrap' }}>
              {['Full history', 'Unified inbox', 'Auto-routing'].map(badge => (
                <span key={badge} style={{ background: 'rgba(10,158,143,0.1)', border: '1px solid rgba(10,158,143,0.28)', color: '#077a6e', fontSize: '0.68rem', padding: '4px 12px', borderRadius: 4, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em' }}>{badge}</span>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {channels.map((ch, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, background: '#060606', border: '1px solid rgba(10,158,143,0.13)', borderRadius: 8, padding: '0.9rem 1.25rem', transition: 'border-color .2s, transform .15s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(10,158,143,0.35)'; e.currentTarget.style.transform = 'translateX(4px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(10,158,143,0.13)'; e.currentTarget.style.transform = 'translateX(0)'; }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: ch.color, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#f0f0f0' }}>{ch.name}</div>
                  <div style={{ fontSize: '0.72rem', color: '#909090', marginTop: 2 }}>{ch.desc}</div>
                </div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#909090" strokeWidth="1.5" strokeLinecap="round"><path d="M9 18l6-6-6-6" /></svg>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 12, borderLeft: '2px solid #056055', paddingLeft: 10 };
const head = { fontSize: 'clamp(1.4rem,2.5vw,1.9rem)', fontWeight: 700, letterSpacing: '-0.03em', color: '#f0f0f0' };
